export enum AccountType {
    CLIENT_DDA = '1',
    CLIENT_BDA = '2', // Account in Fred
    CLIENT_CUSOTIDIAL_ACCOUNT = '3',
    CLIENT_EOA = '4', // Wallet in Fred,
    OMNIBUS_ACCOUNT = '5'
}

export const AccountTypeMap = {
    '1': 'Client DDA',
    '2': 'Client BDA',
    '3': 'Client Custodial Account',
    '4': 'Client EOA',
    '5': 'Omnibus Account'
};